import { render, staticRenderFns } from "./OrdersStatistics.vue?vue&type=template&id=996f1e60&scoped=true&"
import script from "./OrdersStatistics.vue?vue&type=script&lang=js&"
export * from "./OrdersStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OrdersStatistics.vue?vue&type=style&index=0&id=996f1e60&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./OrdersStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996f1e60",
  null
  
)

export default component.exports